export const fetchData = (dispatch, requestData, dispatchFunction) => {
    dispatch(dispatchFunction(requestData));
};
